import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components/macro';
import { Layout } from 'components/organisms';
import {
  Title, LogoUA, Text, Spacer, Button,
} from 'components/atoms';
import { useSpring, animated } from 'react-spring';
import {
  PORTAL_API, isProd, isDeployDev, isDev
} from 'services/constants';
import { useUserContext } from 'context/UserContext';
import { below } from 'services/breakpoints'
import Select from 'react-select';
import thumbnailImage from 'assets/imgs/login-thumbnail.jpg';
import queryString from 'query-string'

const roleOpts = [
  { label: 'Admin', value: 3 },
  { label: 'Editor', value: 2 },
  { label: 'User', value: 1 },
  { label: 'None', value: 0 },
  { label: 'Auto', value: null },
]

const Login = () => {
  const [isLoading, setLoading] = useState(false);
  const [animationEnded, setAnimationEnded] = useState(false);
  const [userRole, setUserRole] = useState({ label: 'Auto', value: null })

  const props = useSpring({
    to: { width: isLoading ? '100%' : '50%' },
    onRest: () => setAnimationEnded(true),
  });
  // eslint-disable-next-line no-unused-vars
  const [_, dispatch] = useUserContext();

  useEffect(() => {
    if (animationEnded && isLoading) {
      // if local development add local parameter
      const localObj = isProd ? {} : { local: true }

      // if local or dev env add level query for testing user roles
      const level = userRole && userRole.value
      const levelObj = (typeof level === 'number' && (isDev || isDeployDev)) ? { level } : {}
      const query = queryString.stringify({ ...localObj, ...levelObj })
      const loginUrl = `${PORTAL_API}/authentication/login?${query}`

      setTimeout(() => {
        window.location = loginUrl;
      }, 1000);
    }
  }, [animationEnded, isLoading, userRole]);

  const handleRoleChange = (opt) => {
    setUserRole(opt)
  }

  return (
    <Layout modifiers={['stretch', 'fullscreen']} style={{ position: 'relative' }}>
      <Top style={props}>
        <LoginForm>
          <Spacer bottom="xl6">
            <LogoUA />
          </Spacer>
          <Spacer bottom="xs3">
            <Title>Editor</Title>
          </Spacer>
          <Spacer bottom="xl">
            <Text>
              Para a gestão dos conteúdos do Portal da Universidade de Aveiro
            </Text>
          </Spacer>
          <Button
            modifiers="dark"
            loading={isLoading}
            onClick={() => setLoading(true)}
          >
            Entrar
          </Button>
        </LoginForm>
      </Top>
      <Bottom>
        {(isDev || isDeployDev) && (
          <Bottom.Select>
            <Text modifiers={['xs', 'light']}>Select user role (dev only):</Text>
            <Select
              options={roleOpts}
              menuPlacement="auto"
              value={userRole}
              onChange={handleRoleChange}
            />
          </Bottom.Select>
        )}
        <BackgroundImage backgroundImage={thumbnailImage} />
      </Bottom>
    </Layout>
  );
};

const Top = styled(animated.div)`
  position: absolute;
  background-color: ${props => props.theme.colors.bgLighter};
  display: flex;
  width: 100%;
  height: 100vh;
  padding: ${props => props.theme.spacing.m};
  padding-left: ${props => props.theme.spacing.xl5};
  padding-top: 10%;
  z-index: ${props => props.theme.values.zIndex.m};
`;

const Bottom = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: ${props => props.theme.values.zIndex.s};
  ${below.sm(css`
    display: none;
  `)}
`;

Bottom.Select = styled.div`
  width: 200px;
  right: 0;
  bottom: 0;
  padding: ${props => props.theme.spacing.xl};
  position: absolute;
  font-size: ${props => props.theme.sizes.xs};
`

const BackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  background-image: url(${props => props.backgroundImage});
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: right top;
`;

const LoginForm = styled.div`
  max-width: 500px;
`;

export default Login;
